window.TABS = window.TABS || {}

window.TABS.validation = (function () {
    return {
        validateStep: function (step) {
            const formEl = document.querySelector('[data-booking-step=' + step + ']')
            const formData = new FormData(formEl)
            const errors = {};
            switch(step) {
                case 'initial':
                    errors.username = TABS.L10n.phone.parse(formData.get('username'), formData.get('countrycode') || undefined).validate()
                    break
                case 'initStudent':
                case 'initContact':
                    errors.mobile = TABS.L10n.phone.parse(formData.get('mobile'), formData.get('countrycode') || undefined).validate()
                    break
                case 'register':
                    errors.username = TABS.L10n.phone.parse(formData.get('username'), formData.get('countrycode') || undefined).validate()
                    errors.first_name = TABS.L10n.firstName.parse(formData.get('first_name')).required().validate()
                    errors.last_name = TABS.L10n.lastName.parse(formData.get('last_name')).required().validate()
                    errors.birth_date = TABS.L10n.date.parse(formData.get('birth_date')).required().validate()
                    errors.email = TABS.L10n.email.parse(formData.get('email')).required().validate()
                    break
                case 'optimaRegister':
                    errors.mobile = TABS.L10n.phone.parse(formData.get('mobile'), formData.get('countrycode') || undefined).validate()
                    errors.first_name = TABS.L10n.firstName.parse(formData.get('first_name')).required().validate()
                    errors.last_name = TABS.L10n.lastName.parse(formData.get('last_name')).required().validate()
                    errors.fnr = TABS.L10n.nationalNumber.parse(formData.get('fnr')).validateNationalNumber()
                    errors.email = TABS.L10n.email.parse(formData.get('email')).required().validate()
                    errors.postal_code = TABS.L10n.zip.parse(formData.get('postal_code')).validate().concat(TABS.L10n.varchar.parse(formData.get('postal_code')).required().validate())
                    errors.city = TABS.L10n.varchar.parse(formData.get('city')).required().validate()
                    errors.address = TABS.L10n.varchar.parse(formData.get('address')).required().validate()
                    break
                case 'reset-password':
                    errors.username = TABS.L10n.phone.parse(formData.get('username'), formData.get('countrycode') || undefined).validate()
                    break;
                case 'contact-person':
                    errors.contact_mobile = TABS.L10n.phone.parse(formData.get('contact_mobile'), formData.get('countrycode') || undefined).validate()
                    errors.contact_first_name = TABS.L10n.firstName.parse(formData.get('contact_first_name')).required().validate()
                    errors.contact_last_name = TABS.L10n.lastName.parse(formData.get('contact_last_name')).required().validate()
                    errors.contact_relation = TABS.L10n.varchar.parse(formData.get('contact_relation')).required().validate()
                    errors.contact_birth_date = TABS.L10n.date.parse(formData.get('contact_birth_date')).required().validate()
                    errors.contact_email = TABS.L10n.email.parse(formData.get('contact_email')).required().validate()
                    break;
                case 'login':
                    if (formEl.querySelectorAll('input[name=username]').length) {
                        // Might be logged in via Vipps. In that case username input will not be present in form
                        errors.username = TABS.L10n.phone.parse(formData.get('username'), formData.get('countrycode') || undefined).validate()
                    }
                    break;
                case 'org-login':
                    errors.username = TABS.L10n.orginizationNumber.parse(formData.get('username')).required().validate()
                    break;
                case 'company-lookup':
                    errors['company-org-number'] = TABS.L10n.orginizationNumber.parse(formData.get('company-org-number')).required().validate()
                    break;
                case 'company-confirm':
                    errors['company-contact-name'] = TABS.L10n.fullName.parse(formData.get('company-contact-name')).required().validate()
                    errors['company-contact-mobile'] = TABS.L10n.phone.parse(formData.get('company-contact-mobile'), formData.get('company-contact-countrycode') || undefined).validate()
                    errors['company-contact-email'] = TABS.L10n.email.parse(formData.get('company-contact-email')).required().validate()
                    break;
                case 'company-add-student':
                    errors.mobile = TABS.L10n.phone.parse(formData.get('mobile'), formData.get('countrycode') || undefined).validate()

                    if (TABS.optima.courseId === null) {
                        // TABS company booking
                        errors.first_name = TABS.L10n.firstName.parse(formData.get('first_name')).required().validate()
                        errors.last_name = TABS.L10n.lastName.parse(formData.get('last_name')).required().validate()
                        errors.birth_date = TABS.L10n.date.parse(formData.get('birth_date')).required().validate()
                    }

                    if (TABS.optima.hasResourcePool) {
                        errors['resource-class-id'] = Number.isInteger(parseInt(formData.get('resource-class-id'))) ? [] : [TABS.$t('Du må velge et kjøretøy')];
                    }

                    errors.email = TABS.L10n.email.parse(formData.get('email')).validate()
                    break;
            }

            TABS.booking.debug(errors)
            const errorCount = TABS.validation.toggleFormErrors(formEl, errors)
            TABS.booking.debug({errorCount})
            return errorCount === 0;
        },

        toggleFormErrors: function (formEl, errors) {
            return Object.keys(errors)
                .reduce((carry, key) => {

                    const message = errors[key][0]
                    if (message) {
                        TABS.validation.showValidationError(formEl, key, message)
                    } else {
                        TABS.validation.hideValidationError(formEl, key)
                    }
                    return carry + errors[key].length
                }, 0)
        },

        showValidationError: function (formEl, key, message) {
            // console.log({formEl, key, message})
            TABS.booking.debug({formEl, key, message})
            const formGroup = formEl.querySelector('[name=' + key + ']').closest('.form-group')
            formGroup.classList.add('has-error', 'has-feedback')
            let errorEl = formGroup.querySelector('#' + key + '-error')
            if (errorEl === null) {
                errorEl = document.createElement('em')
                errorEl.id = key + '-error'
                errorEl.classList.add('text-danger')
            }
            errorEl.innerText = message
            TABS.booking.debug({errorEl})
            formGroup.appendChild(errorEl)
        },


        hideValidationError: function (formEl, key) {
            const formGroup = formEl.querySelector('[name=' + key + ']').closest('.form-group')
            formGroup.classList.remove('has-error', 'has-feedback')
            const errorEl = formGroup.querySelector('#' + key + '-error')
            if (errorEl !== null) {
                errorEl.parentNode.removeChild(errorEl)
            }
        },

        clearValidationErrors: function (formEl) {
            formEl.querySelectorAll('.form-group.has-error').forEach(function (formGroup) {
                formGroup.classList.remove('has-error', 'has-feedback')
                const errorEl = formGroup.querySelector('em')
                if (errorEl !== null) {
                    errorEl.parentNode.removeChild(errorEl)
                }
            })
        }
    }
})();